import React from 'react';
import { CircularProgress, Icon, VStack, Text } from '@chakra-ui/react';
import { Banner } from '@olo-web/components/atoms/Banner';
import { useDropzone } from 'react-dropzone';
import { UploadCloud } from 'react-feather';

type T = {
  onDrop: ([key]: any) => void;
  isLoading: boolean;
  maxSize?: number;
};

export const ImageDropzone = ({ onDrop, isLoading }: T) => {
  const handleDrop = (acceptedFiles): void => {
    if (!acceptedFiles?.length) return;
    onDrop(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps, isDragActive, fileRejections } = useDropzone({
    onDrop: handleDrop,
    maxFiles: 1,
    accept: ['image/jpg', 'image/jpeg', 'image/png', 'image/x-icon'],
  });

  return (
    <VStack w="100%" p={{ base: 2, md: 4 }}>
      {fileRejections?.[0]?.errors?.[0]?.message && (
        <Banner status="error" description={fileRejections[0].errors[0].message} />
      )}
      <VStack
        {...getRootProps()}
        borderStyle="solid"
        borderColor={isDragActive ? 'primary.200' : 'blackAlpha.200'}
        borderWidth="2px"
        p={4}
        borderRadius="md"
        w="100%"
        _hover={{
          borderColor: 'primary.200',
          cursor: 'pointer',
        }}
      >
        <input {...getInputProps()} />
        {isLoading ? (
          <CircularProgress isIndeterminate h={10} w={10} color="primary.350" />
        ) : (
          <Icon as={UploadCloud} h={10} w={10} />
        )}
        <Text textStyle="subtitle2" pt={4}>
          {isLoading
            ? 'Uploading your image...'
            : isDragActive
            ? 'Drop image here'
            : 'Drag a file or click here'}
        </Text>
        <Text textStyle="p">to start an upload</Text>
        <Text textStyle="label" fontStyle="italic">
          accepts jpg or png
        </Text>
      </VStack>
    </VStack>
  );
};
